import React, { useEffect, useState } from 'react';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import "./style.sass";
import { useStorage64 } from 'hooks/useStorageBase64';
import { putRequestCard } from 'services/putRequestCard';
import { ModalErrorSolicitarCredito } from 'components/Error/ErrorSolicitarCredito';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { HeaderMobileSolicitud } from 'components/Credito/HeaderPasosMobile';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { dateFormatNumberInvert } from 'functions/dateFormat'
import { dataLayerButtons } from 'functions/dataLayerFunction'
import { useToken } from 'hooks/useToken'

import {repareTextCredit, removeAcentCredit } from 'functions/repareDataService'

export function InformacionFinancieraMobile({ nextPage, cancelar, setNumFolio, setErrorC }) {

    const history = useHistory();
    const [datosFinancieros, setDatosFinancieros] = useState(false);
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    const [crearTicket, setCrearTicket] = useState(false);
    const [infoPersonalMobileStorage,] = useStorage64('infoPersonalMobileStorage', '');
    const [infoTrabajoMobileStorage,] = useStorage64('infoTrabajoMobileStorage', '');
    const [, setInfoFinacieraMobileStorage] = useStorage64('infoFinancieraMobileStorage', '');

    const [pTieneTarjeta, setPtieneTarjeta] = useState(false);
    const [pTieneCreditoHipotecario, setPtienCreditoHipotecario] = useState(false);
    const [pCreditoAutomotriz, setPCreditoAutomotriz] = useState(false);
    const [permisos, setPermisos] = useState(false);

    const [inputUltimosDigitos, setInputUltimosDigitos] = useState();

    const [errorCode, setErrorCode] = useState();
    const [sectionActive, setSectionActive] = useState(null);
    const [showModalErr, setShowModalErr] = useState(false);

    const refreshCyR = useToken({firstActive: false, name: "infoFinMov"})

    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            tieneTarjeta: datosFinancieros.tieneTarjeta,
            ultimosDigitos: datosFinancieros.ultimosDigitos,
            tieneCreditoHipotecario: datosFinancieros.tieneCreditoHipotecario,
            tieneCreditoAutomotriz: datosFinancieros.tieneCreditoAutomotriz,
            permisos: datosFinancieros.permisos
        }
    });

    // guarda la informacion enviada en el formulario
    const [tokenJWT, setTokenJWT] = useState(false)
    const sendFormInformacionFinanciera = data => {
        setDatos({
            "STarjeta": data.tieneTarjeta,
            "Digitos": data.ultimosDigitos,
            "SHipotecario": data.tieneCreditoHipotecario,
            "SAutomotriz": data.tieneCreditoAutomotriz,
            "Autorizacion": data.permisos
        })
        setTokenJWT(true)
    };

    useEffect(()=>{
        if(tokenJWT){
            refreshCyR.forceToken(true)
            setTokenJWT(false)
        }
    },[tokenJWT])

    useEffect(()=>{
        if(refreshCyR.newToken){
            SetReturnForm(true);
        }
    },[refreshCyR.newToken])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    // al recibir data del formulario se guarda en variable datos financieros y se envia peticion al servicio
    useEffect(() => {
        if (returnForm) {
            let NombreFIX = repareTextCredit( String(infoPersonalMobileStorage.Nombre).trim() );
            let APaternoFIX = repareTextCredit( String(infoPersonalMobileStorage.APaterno).trim() );
            let AMaternoFIX = repareTextCredit( String(infoPersonalMobileStorage.AMaterno).trim() );
            let DomicilioFIX = repareTextCredit( String(infoPersonalMobileStorage.Domicilio?.substr(0,30) ).trim() );
            let ColoniaFIX = repareTextCredit( String(infoPersonalMobileStorage.Colonia).trim());
            let CiudadFIX = repareTextCredit( String(infoPersonalMobileStorage.Ciudad?.substr(0,20) ).trim() );
            let EstadoFIX = repareTextCredit( String(infoPersonalMobileStorage.Estado).trim() );
            let EmpresaFIX = repareTextCredit( String(infoTrabajoMobileStorage.Empresa).trim() );
            let DireccionEmpleoFIX = repareTextCredit( String(infoTrabajoMobileStorage.DireccionEmpleo).trim() );
            let ColoniaEmpFIX = repareTextCredit( String(infoTrabajoMobileStorage.ColoniaEmp).trim() );
            let MunicipioEmpFIX = repareTextCredit( String(infoTrabajoMobileStorage.MunicipioEmp?.substr(0,20) ).trim() );
            let EstadoEmpFIX = repareTextCredit( String(infoTrabajoMobileStorage.EstadoEmp).trim() );
            let OcupacionFIX = repareTextCredit( String(infoTrabajoMobileStorage.Ocupacion).trim() );


            let Tienda = infoPersonalMobileStorage.Tienda;
            let Nombre = removeAcentCredit( NombreFIX );
            let APaterno = removeAcentCredit( APaternoFIX );
            let AMaterno = removeAcentCredit( AMaternoFIX );
            let Email = infoPersonalMobileStorage.Email;
            let Celular = Number(infoPersonalMobileStorage.Celular);
            let Telefono = Number(infoPersonalMobileStorage.Celular);

            let Genero = infoPersonalMobileStorage.Genero;
            let FechaNacimiento = Number(dateFormatNumberInvert(infoPersonalMobileStorage.FechaNacimiento) );
            let RFC;
            if(infoPersonalMobileStorage.RFC.length > 10){
                RFC = infoPersonalMobileStorage.RFC;
            }else{
                RFC = `${infoPersonalMobileStorage.RFC}XXX`;
            }
            let Domicilio = removeAcentCredit( DomicilioFIX );
            let CP = String(infoPersonalMobileStorage.CP).trim();
            let Colonia = removeAcentCredit( ColoniaFIX );
            let Ciudad = removeAcentCredit( CiudadFIX );
            let Estado = removeAcentCredit( EstadoFIX );
            let TipoVivienda = infoPersonalMobileStorage.TipoVivienda;
            let MontoRenta = Number(infoPersonalMobileStorage.MontoRenta);
            let TiempoResAnio = Number(infoPersonalMobileStorage.TiempoResAnio);
            let TiempoResMes = Number(infoPersonalMobileStorage.TiempoResMes);
            let Nodependientes = Number(infoPersonalMobileStorage.Nodependientes);

            let Empresa = removeAcentCredit( EmpresaFIX );
            let TipoEmpresa = infoTrabajoMobileStorage.TipoEmpresa;
            let TelEmpresa = Number(infoTrabajoMobileStorage.TelEmpresa);
            let Ext = Number(infoTrabajoMobileStorage.Ext);
            let DireccionEmpleo = removeAcentCredit( DireccionEmpleoFIX );
            let CPEmp = String(infoTrabajoMobileStorage.CPEmp).trim();
            let ColoniaEmp = removeAcentCredit( ColoniaEmpFIX );
            let MunicipioEmp = removeAcentCredit( MunicipioEmpFIX );
            let EstadoEmp = removeAcentCredit( EstadoEmpFIX );
            let Ocupacion = removeAcentCredit( OcupacionFIX );
            let TiempoEmpAnio = Number(infoTrabajoMobileStorage.TiempoEmpAnio);
            let TiempoEmpMes = Number(infoTrabajoMobileStorage.TiempoEmpMes);
            let Ingmensual = Number(infoTrabajoMobileStorage.Ingmensual);
            let OtroIngresos = infoTrabajoMobileStorage.OtroIngresos;
            let FuenteOtroIngresos = infoTrabajoMobileStorage.FuenteOtroIngresos;

            let STarjeta = datos.STarjeta;
            let Digitos
            if(STarjeta === "SI"){
                Digitos = datos.Digitos;
            }else{
                Digitos = "0000"
            }
            let SHipotecario = datos.SHipotecario;
            let SAutomotriz = datos.SAutomotriz;
            let Autorizacion = datos.Autorizacion;

            setDatosFinancieros(datos);
            setInfoFinacieraMobileStorage(datos);

            // console.log("datos para servicio----->",
            //     Tienda, "-- nombre:", Nombre, "-- apaterno:", APaterno,"-- amaterno:",AMaterno,"-- genero:", Genero,"-- fechanacimiento:", FechaNacimiento, "-- telefono:",
            //     Telefono, "-- rfc:", RFC, "-- domicilio:", Domicilio, "-- cp:", CP, "-- colonia:", Colonia, "-- ciudad:",
            //     Ciudad, "-- estado:", Estado, "-- tipovivienda:", TipoVivienda, "-- montorenta:", MontoRenta, "-- anoresidencia:", TiempoResAnio, "-- mesresidencia:", TiempoResMes, "-- dependientes:", Nodependientes, "-- celular:",
            //     Celular, "-- empresa:", Empresa, "-- tipo empresa:", TipoEmpresa, "-- tel empresa:", TelEmpresa, "-- extension empresa:", Ext, "-- direccion empleo:",
            //     DireccionEmpleo, "-- cp empresa:", CPEmp, "-- colonia empresa: ", ColoniaEmp, "-- municipio empresa:", MunicipioEmp, "-- estado empresa:", EstadoEmp, "-- ocupacion:", Ocupacion, "-- anioempresa:", TiempoEmpAnio, "--",
            //     TiempoEmpMes, "-- ingreso mensual:", Ingmensual, "-- otros ingresos:", OtroIngresos, "-- fuente otros:", FuenteOtroIngresos,"-- email:",
            //     Email, "-- starjeta:", STarjeta, "-- digitos:", Digitos,"-- shipo:", SHipotecario, "-- sauto:", SAutomotriz, "-- autorizacion:", Autorizacion)

            putRequestCard({
                Tienda, Nombre, APaterno, AMaterno, Email,
                Genero, FechaNacimiento, Telefono, RFC, Domicilio, CP, Colonia, Ciudad, Estado,
                TipoVivienda, MontoRenta, TiempoResAnio, TiempoResMes, Nodependientes, Celular,
                Empresa, TipoEmpresa, TelEmpresa, Ext, DireccionEmpleo, CPEmp, ColoniaEmp, MunicipioEmp,
                EstadoEmp, Ocupacion, TiempoEmpAnio, TiempoEmpMes, Ingmensual, OtroIngresos, FuenteOtroIngresos,
                STarjeta, Digitos, SHipotecario, SAutomotriz, Autorizacion
            })
                .then(setCrearTicket)

            SetReturnForm(false);
        }
    }, [returnForm])

    // si la respuesta es ticket creado === 200 redirecciona a solicitud finalizada
    const [typeError, setTypeError] = useState('formShort')
    useEffect(() => {
        if (crearTicket) {
            if (Number(crearTicket.statusCode) === 200) {
                setNumFolio(crearTicket.data);
                dataLayerButtons({eventName: "credito_enviarsolicitud"})
                nextPage(4);
            }
            else if (Number(crearTicket.statusCode) === 404) {
                setShowModalErr(true);
                setErrorCode(crearTicket.statusCode);
                setSectionActive('requestCredit');
            }
            else if (crearTicket.statusCode === 400) {
                let dataError = JSON.parse(crearTicket.data)
                if (dataError) {
                    // console.log(dataError);
                    setShowModalErr(true);
                    setSectionActive(null);
                    setErrorCode({ codMen: dataError?.codMen });
                    setTypeError('formShort')
                }
            } else if(crearTicket.statusCode >= 500){
                setErrorC(crearTicket.statusCode)
            }
        }
    }, [crearTicket])

    const seleccionarTieneTarjeta = (e) => {
        setPtieneTarjeta(e.target.value);
    };
    const seleccionarTieneCreditoHipotecario = (e) => {
        setPtienCreditoHipotecario(e.target.value);
    };
    const seleccionarCreditoAutomotriz = (e) => {
        setPCreditoAutomotriz(e.target.value);
    };
    const seleccionarPermisos = (e) => {
        setPermisos(e.target.value);
    };

    const valTieneTarjeta = {
        required: 'Campo obligatorio',
    };
    const valUltimosDigitos = {
        required: 'Campo obligatorio',
        minLength: {
            value: 4,
            message: 'Faltan dígitos. Debe ser de al menos 4 dígitos'
        },
        maxLength: {
            value: 4,
            message: 'Debe contener máximo 4 dígitos'
        }
    };
    const valTieneCreditoHipotecario = {
        required: 'Campo obligatorio',
    };
    const valCreditoAutomotriz = {
        required: 'Campo obligatorio',
    };
    const valPermisos = {
        required: 'Campo obligatorio',
    };

    // valida creacion de ticket y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'requestCredit') {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}home`);
        }
    }

    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                    <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />

                    <div className="contenedorGeneral top0">
                        <div className="boxSolicitud">

                            <HeaderMobileSolicitud titulo={"PREGUNTAS"} posicion={3} totalItems={3} />

                            <form onSubmit={handleSubmit(sendFormInformacionFinanciera)} className="formularioSolicitudMobile">
                                <>
                                    <div className="divFormMobile">
                                        <div className="subCampo">
                                            <p className="copyAviso">¿Cuentas con tarjeta bancaria?</p>

                                            <ul className={pTieneTarjeta === false && errors.tieneTarjeta && errors.tieneTarjeta.message ? "ulPreguntasMo conError" : "ulPreguntasMo"} onChange={seleccionarTieneTarjeta}>
                                                <li id="negativo">
                                                    <input className="radio" id="si" type="radio" value="SI" name="tieneTarjeta" checked={pTieneTarjeta === "SI" ? true : false} ref={register(valTieneTarjeta)} />
                                                    <label name="si" htmlFor="si"> Si </label>
                                                </li>
                                                <li id="positivo">
                                                    <input className="radio" id="no" type="radio" value="NO" name="tieneTarjeta" checked={pTieneTarjeta === "NO" ? true : false} ref={register(valTieneTarjeta)} />
                                                    <label name="no" htmlFor="no"> No </label>
                                                </li>
                                            </ul>

                                            {pTieneTarjeta === false && errors.tieneTarjeta && errors.tieneTarjeta.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                            {pTieneTarjeta === "SI"
                                                ? <div className="boxCompletar">
                                                    {/* <InputTypeAndroidDos
                                                        type="text"
                                                        id="ultimosDigitos"
                                                        name="ultimosDigitos"
                                                        autocomplete="ultimosDigitos"
                                                        placeholder="Últimos 4 números de ella"
                                                        className="desktopInput"
                                                        errorMessage={errors.ultimosDigitos && errors.ultimosDigitos.message}
                                                        onKeyDown={function (e) {
                                                            if ((e.keyCode < '48' || e.keyCode > '57') && e.keyCode != "8") {
                                                                e.preventDefault()
                                                            }
                                                        }}
                                                        refs={register(valUltimosDigitos)}
                                                        maxLength={4}
                                                    /> */}
                                                    <InputTypeAndroid
                                                        type="text"
                                                        name="ultimosDigitos"
                                                        id="ultimosDigitos"
                                                        placeholder="Últimos 4 números de ella"
                                                        refs={register(valUltimosDigitos)}
                                                        className="desktopInput"
                                                        autocomplete='ultimosDigitos'
                                                        setNumero={setInputUltimosDigitos}
                                                        value={inputUltimosDigitos}
                                                        errorMessage={errors.ultimosDigitos && errors.ultimosDigitos.message}
                                                        pattern={'number'}
                                                        maxLength={4}
                                                    />
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </div>

                                    <div className="divFormMobile">
                                        <div className="campo">
                                            <div className="subCampo">
                                                <p className="copyAviso">¿Cuentas con un crédito hipotecario bancario?</p>

                                                <ul className={pTieneCreditoHipotecario === false && errors.tieneCreditoHipotecario && errors.tieneCreditoHipotecario.message ? "ulPreguntasMo conError" : "ulPreguntasMo"}
                                                    onChange={seleccionarTieneCreditoHipotecario}>
                                                    <li id="positivo">
                                                        <input className="radio" id="si" type="radio" value="SI" name="tieneCreditoHipotecario" checked={pTieneCreditoHipotecario === "SI" ? true : false} ref={register(valTieneCreditoHipotecario)} />
                                                        <label name="si" htmlFor="si"> Si </label>
                                                    </li>
                                                    <li id="negativo">
                                                        <input className="radio" id="no" type="radio" value="NO" name="tieneCreditoHipotecario" checked={pTieneCreditoHipotecario === "NO" ? true : false} ref={register(valTieneCreditoHipotecario)} />
                                                        <label name="no" htmlFor="no"> No </label>
                                                    </li>
                                                </ul>

                                                {pTieneCreditoHipotecario === false && errors.tieneCreditoHipotecario && errors.tieneCreditoHipotecario.message
                                                    ? <div className="error">Campo obligatorio</div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="divFormMobile">
                                        <div className="campo">
                                            <div className="subCampo">
                                                <p className="copyAviso">¿Has ejercido algún crédito automotriz bancario en los últimos 24 meses?</p>

                                                <ul className={pCreditoAutomotriz === false && errors.tieneCreditoAutomotriz && errors.tieneCreditoAutomotriz.message ? "ulPreguntasMo conError" : "ulPreguntasMo"} onChange={seleccionarCreditoAutomotriz}>
                                                    <li id="positivo">
                                                        <input className="radio" id="si" type="radio" value="SI" name="tieneCreditoAutomotriz" checked={pCreditoAutomotriz === "SI" ? true : false} ref={register(valCreditoAutomotriz)} />
                                                        <label name="si" htmlFor="si"> Si </label>
                                                    </li>
                                                    <li id="negativo">
                                                        <input className="radio" id="no" type="radio" value="NO" name="tieneCreditoAutomotriz" checked={pCreditoAutomotriz === "NO" ? true : false} ref={register(valCreditoAutomotriz)} />
                                                        <label name="no" htmlFor="no"> No </label>
                                                    </li>
                                                </ul>

                                                {pCreditoAutomotriz === false && errors.tieneCreditoAutomotriz && errors.tieneCreditoAutomotriz.message
                                                    ? <div className="error">Campo obligatorio</div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>

                                <>
                                    <div className="divFormMobile">
                                        <div className="campo">
                                            <p className="copyAviso">¿Autorizas a Claroshop.com, S.A. de C.V. a que consulte antecedentes crediticios en alguna sociedad de información crediticia, declarando que conoces la naturaleza, alcance y uso de Claroshop.com, S.A. de C.V. le dará a esta información?</p>
                                            <p className="copyAviso">Reconozco haber leído y aceptado los términos y condiciones del <a className="aLink" href={`${BASE_PATH}contrato-credito/`} target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>.</p>

                                            <ul className={permisos === false && errors.permisos && errors.permisos.message ? "ulPreguntasMo conError" : "ulPreguntasMo"} onChange={seleccionarPermisos}>
                                                <li id="autorizaSears" className="liAutorizacion">
                                                    <input className="radio" id="permisos" type="checkbox" value="SI" name="permisos" ref={register(valPermisos)} />
                                                    <label name="permisos" htmlFor="permisos" className="acepto"> Si, Acepto </label>
                                                </li>
                                            </ul>

                                            {permisos === false && errors.permisos && errors.permisos.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </>

                                <div className="boxBotonesMobile">
                                    <button className="btnRedM">Enviar solicitud</button>
                                    <button className="btnWhiteM" onClick={cancelar}>Cancelar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {showModalErr &&
                <ModalErrorSolicitarCredito
                    errorCode={errorCode}
                    section={typeError}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}
